import CrudReducer from './crudReducer';

const cr = new CrudReducer('onboarding_banner_widget');

const reducer = cr.Reducer;

export default reducer;
